var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-between-y"},[_c('el-dialog',{attrs:{"title":"所有商品","visible":_vm.dialogProduct},on:{"update:visible":function($event){_vm.dialogProduct=$event}}},[_c('product-all')],1),_c('sale-order-all',{ref:"tab"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }